module.exports = __webpack_public_path__ + "static/media/HA problem.2b6c74f5.png";